import { Box, Divider, Typography } from '@mui/material';

export default function GraphMainHeader({ children }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
            <Typography variant="h5" component="h5" sx={{ my: 3, textAlign: 'center', fontWeight: 'bold' }}>
                {children}
            </Typography>
            <Divider sx={{ mb: 2 }} />
        </Box>
    )
}